import React, { useCallback, useRef } from 'react';
import { useUserContext } from '../../common/user-context';
import { addRecentSearch, PRODUCT_SEARCH_DIALOG_KEY } from '@atlassian/search-common';
import { useFeaturesContext } from '../features-context/features-context';
import { useProductContext } from '../product-router';
import { useQuery } from '../query-context';
export const usePersistRecentSearches = overrideQuery => {
  const previousQuery = useRef(null);
  const {
    isRecentSearchEnabled = false
  } = useFeaturesContext();
  const {
    user
  } = useUserContext();
  const {
    query
  } = useQuery();
  const {
    getActiveProduct
  } = useProductContext();
  const product = getActiveProduct();
  const persistRecentSearch = useCallback(() => {
    if (isRecentSearchEnabled && user !== null && user !== void 0 && user.id && product !== null && product !== void 0 && product.id) {
      if (overrideQuery && overrideQuery.trim() !== '') {
        addRecentSearch(overrideQuery, user.id, product.id, PRODUCT_SEARCH_DIALOG_KEY);
      } else if (previousQuery.current !== query && query.trim() !== '') {
        addRecentSearch(query, user.id, product.id, PRODUCT_SEARCH_DIALOG_KEY);
        previousQuery.current = query;
      }
    }
  }, [isRecentSearchEnabled, product === null || product === void 0 ? void 0 : product.id, query, user.id, overrideQuery]);
  const onClick = useCallback(() => {
    persistRecentSearch();
  }, [persistRecentSearch]);
  const onEnter = useCallback(event => {
    if (event.key === 'Enter') {
      persistRecentSearch();
    }
  }, [persistRecentSearch]);
  return [onClick, onEnter];
};

/**
 * This component is used in {@link MetaContextProvider} to intercept
 * clicks and enter hit of any kind (eg - result, filter, feedback, input etc).
 */
export const PersistRecentSearch = ({
  children,
  overrideQuery
}) => {
  const [onClick, onEnter] = usePersistRecentSearches(overrideQuery);
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    onKeyDown: onEnter,
    style: {
      width: '100%'
    },
    "data-testid": "persist-recent-search"
  }, children);
};